import React, { PureComponent } from 'react';
import { IReducerState } from '../states/renditionStates';
import { connect } from 'react-redux';
import $ from 'jquery';
import _, { isEmpty, isEqual } from 'lodash';
import RenditionUrlGenerator from "../utils/api/renditionUrlGenerator";
import servicesConfig from '../services/servicesConfig';
import { fetchCvrCopyURL } from '../actions/asyncStateAction';
import { addParam, getOpenDocumentLink } from '../utils/general/general';
import { bullbearAnchor, captureAndCopyScreenshotWithHtml } from './copyFigure';
 
 
interface ICopyFigureUrlPopupProps {
    docHeaderSectionJson: any;
    copyFigureURLData: any;
    anchorValue?: string;
    loadCvrCopyURLData: (s: string) => {};
}
 
export class CopyFigureUrlPopup extends PureComponent<ICopyFigureUrlPopupProps, any> {
         public CopyURLButtonRef: any = React.createRef();
 
         constructor(props: ICopyFigureUrlPopupProps) {
           super(props);
            // Call copyFigureUrl and store the result in the state
            const { figure, docLink } = this.copyFigureUrl();
            this.state = {
              figure,
              docLink,
              copyFigureUrl: "",
            };
         }

         componentDidUpdate() {
          // Update state when copyFigureURLData?.copyURL changes
          if (!isEmpty(this.props.copyFigureURLData?.copyURL)) {
            this.setState({ copyFigureUrl: this.props.copyFigureURLData.copyURL });
          }
        }
 
         public copyFigureUrl() {
           let figure = $("#right-pane .fg.carousel-item.active div");
           if (figure.length === 0) {
            if (isEqual(this.props.anchorValue, 'dataSummary') || isEqual(this.props.anchorValue, 'earningEstimates')) {
              figure = $(".modal-body table");
            } else {
              figure = $(".modal-body-inner").length > 0 ? $(".modal-body-inner") : $(".modal-body");
            }
          }
           let location: any = figure?.attr("data-name");
           if (!isEmpty(this.props.anchorValue)) {
             location = this.props.anchorValue;
           }
           const anchorForBullbear = bullbearAnchor();
           let docLink = getOpenDocumentLink(window.HTML_RENDITION.initialData.doc_id);
           docLink = addParam(docLink, "anchor", !(_.isEmpty(anchorForBullbear)) ? anchorForBullbear : location);
           const environment = window.HTML_RENDITION?.initialData?.environment;
           this.props.loadCvrCopyURLData(RenditionUrlGenerator.URL_GENERATOR.environments(environment) + docLink);
           return {figure, docLink};
         }
 
         public render() {
           console.log("Copyfigure render");
           const {figure, docLink} = this.state;
           const { docHeaderSectionJson } = this.props;
           const copyHeadline = Base64.decode(window.HTML_RENDITION.initialData.doc_headline);
           const copyURLHTML = [];
           const copiedTextValue = docHeaderSectionJson?.i18n?.figureCopiedConfirmationTooltip;
           
           copyURLHTML.push(
             <div key="0">
               <div className="copy-headline-title-copy-url">
                 {docHeaderSectionJson?.i18n?.copyFigure}
               </div>
               <div>
                 <div id="copyHeadline">
                   <a
                     tabIndex={0}
                     id="copyHeadlineText"
                     href={this.state.copyFigureUrl || "#"}
                     target="_blank"
                     aria-label={copyHeadline}
                     role="link"
                   >
                     {copyHeadline}
                   </a>
                 </div>
                 <input
                   tabIndex={0}
                   role="button"
                   type="button"
                   id="CopyHeadlineButton"
                   className="copyButton"
                   name="submit"
                   value={docHeaderSectionJson?.i18n?.copyButton}
                   onClick={(e) =>
                     captureAndCopyScreenshotWithHtml(
                      figure,
                      docLink,
                      this.state.copyFigureUrl
                     )
                   }
                 />
               </div>
               <div>
                 <div>
                   <input
                     tabIndex={0}
                     type="text"
                     aria-labelledby="copyURLTitle"
                     id="copyURL"
                     className="copy-url-modal"
                     name="copyURL"
                     value={
                      this.state.copyFigureUrl || "Loading..."
                     }
                     readOnly
                   />
                 </div>
                 <input
                   onClick={() =>
                     captureAndCopyScreenshotWithHtml(
                       figure,
                       docLink,
                       this.state.copyFigureUrl,
                       true
                     )
                   }
                   ref={this.CopyURLButtonRef}
                   role="button"
                   tabIndex={0}
                   type="button"
                   id="CopyURLButton"
                   className="copyButton"
                   name="submit1"
                   value={docHeaderSectionJson?.i18n?.copyButton}
                   data-clipboard-action="copy"
                   data-clipboard-target="#copyURL"
                 />
               </div>
             </div>
           );
           return (
             <>
             <div className="copy-figure-container" style={{ overflow: "hidden" }}>
               {copyURLHTML}
             </div>
             {<div className="copy-figure-tooltip">{copiedTextValue}</div>}
             </>
           );
         }
       }
 
const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
        copyFigureURLData: state.asyncStateReducer.copyFigureURLData,
    };
};
 
const mapDispatchToProps = (dispatch: any) => ({
    loadCvrCopyURLData: (copyURL: string) => dispatch(fetchCvrCopyURL(Object.assign(servicesConfig.GET_CVR_URL, { 'url_parameter': ['url=' + encodeURIComponent(copyURL)] }), true)),
    });
 
 
export default connect(mapStateToProps, mapDispatchToProps)(CopyFigureUrlPopup);